import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import { IRoomDiscount } from 'pages/PageApplicationNew/interfaces';
import { StyledTableCell, StyledTableRow } from 'components/StyledTableComponents';
import { Cancel } from '@material-ui/icons';

interface IProps {
  title: string;
  discounts: IRoomDiscount[];
  onClose: () => void;
}

const DiscountsDialogs: React.FC<IProps & DialogProps> = ({ open, onClose, discounts, title }) => {
  // Main render
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle>
        <b>{title}</b>
      </DialogTitle>

      <DialogContent dividers>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Дата начала скидки</StyledTableCell>
                <StyledTableCell align="left">Дата окончания скидки</StyledTableCell>
                <StyledTableCell align="left">% скидки</StyledTableCell>
                <StyledTableCell align="left">Сумма скидки</StyledTableCell>
                <StyledTableCell align="left">Комментарий</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {discounts.map((v, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>{moment(new Date(v.dateFrom)).format('DD.MM.YYYY')}</StyledTableCell>
                  <StyledTableCell>{moment(new Date(v.dateTo)).format('DD.MM.YYYY')}</StyledTableCell>
                  <StyledTableCell>{v.discountPercentage === 0 ? '-' : v.discountPercentage}</StyledTableCell>
                  <StyledTableCell>{v.fixedAmount === 0 ? '-' : v.fixedAmount}</StyledTableCell>
                  <StyledTableCell>{v.comment}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose} startIcon={<Cancel />}>
          Отменить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscountsDialogs;
